// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3994":"60999843","5177":"579fc57c"}[chunkId] + ".chunk.css";
};